import { render, staticRenderFns } from "./PersonalEditLocalization.vue?vue&type=template&id=5f8e150e&scoped=true&"
import script from "./PersonalEditLocalization.vue?vue&type=script&lang=ts&"
export * from "./PersonalEditLocalization.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalEditLocalization.vue?vue&type=style&index=0&id=5f8e150e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e150e",
  null
  
)

export default component.exports